import { Radio } from 'lucide-react';
import { useRouterState } from '@tanstack/react-router';
import { Button } from '@/components/atoms/button';
import { useLiveCallMonitor } from '@/contexts/live-calls';

/**
 * The way back to a live call after the bubble has been dismissed — and the
 * quiet, always-there count of what is on the phones.
 *
 * It sits in the header rail with the dialer and the conference button, appears
 * only while calls are actually up, and opens the same monitoring sheet the
 * bubble does. Dismissing the bubble is therefore never a dead end.
 */
export function LiveCallsTrigger() {
  const monitor = useLiveCallMonitor();
  // On the Live calls page there is no sheet to open — the page is the surface.
  const onLiveCallsPage = useRouterState({
    select: (state) => state.location.pathname.startsWith('/dashboard/live-calls'),
  });

  if (!monitor?.allowed || onLiveCallsPage) return null;
  const count = monitor.calls.length;
  if (count === 0) return null;

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className="relative h-9 w-9"
      aria-label={`Live calls, ${count} in progress`}
      aria-expanded={monitor.sheetOpen}
      onClick={monitor.restore}
    >
      <Radio className="h-[18px] w-[18px]" />
      <span className="absolute top-1 right-1 flex h-3.5 min-w-[14px] items-center justify-center rounded-full bg-portal-accent px-1 text-[8px] leading-none font-semibold text-portal-accent-foreground">
        {count > 9 ? '9+' : count}
      </span>
    </Button>
  );
}
